import _regeneratorRuntime from "E:/AirVenture/frontend/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "E:/AirVenture/frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import CreateUpdateTemplate from "@/view/pages/partials/Create-Update-Template.vue";
import { PreventDialogEventBus } from "@/core/lib/prevent.reload.lib";
import { QUERY, POST, PUT } from "@/core/services/store/request.module";
import CustomerPersonDialog from "@/view/pages/partials/Select-Customer-Person.vue";
import CustomerPropertyDialog from "@/view/pages/partials/Select-Customer-Property.vue";
import CustomerBillingDialog from "@/view/pages/partials/Select-Customer-Billing.vue";
import DateRangePicker from "@/view/pages/partials/DateRangePicker.vue";
import DatePicker from "@/view/pages/partials/Datepicker.vue";
import ContractLineItemNew from "@/view/pages/partials/Line-Item-New.vue";
import LineItemMixin from "@/core/lib/line-item/line.item.mixin";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import { TermConditionEventBus } from "@/core/lib/term.condition.lib";
import { NoteAttachmentEventBus } from "@/core/lib/note.attachment.lib";
import ContractTermsConditions from "@/view/pages/partials/Terms-Conditions.vue";
import ContractNotesAttachment from "@/view/pages/partials/Notes-Attachment.vue";
import { concat, compact, filter, isEmpty, toSafeInteger, map } from "lodash";
import moment from "moment-timezone";
moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);
export default {
  mixins: [CommonMixin, ValidationMixin, LineItemMixin],
  name: "contract-create",
  title: "Create Contract",
  data: function data() {
    return {
      formLoading: false,
      pageLoading: false,
      contractCreated: false,
      lineItemCreated: false,
      customer: {},
      property: {},
      billing: {},
      barcodeSetting: {},
      contractCreate: {
        job_title: null,
        description: null,
        property_person_notify: 1,
        billing_person_notify: 1,
        rating: 1,
        reference: null,
        duration_value: 1,
        duration_type: "year",
        contract_start: moment().format("YYYY-MM-DD"),
        contract_end: moment().add(1, "year").format("YYYY-MM-DD"),
        sales_executive: null,
        prepared_by: null,
        is_contract: null,
        duration: null,
        total_service: null,
        discount_value: null,
        discount_value_type: null,
        tax_applied: null,
        adjustment: null,
        sales: null
      },
      durationTypeList: [{
        text: "Year",
        value: "year"
      }, {
        text: "Month",
        value: "month"
      }],
      customerPersonDialog: false,
      customerBillingDialog: false,
      customerPropertyDialog: false,
      customerPerson: 0,
      customerProperty: 0,
      customerBilling: 0,
      person_type: null,
      ticketId: null,
      visitId: null,
      invoiceId: null,
      contractId: null,
      property_contact_person: {},
      billing_contact_person: {},
      salesExecutiveList: [],
      lineItem: [],
      equipments: [],
      dbLineItems: [],
      dbEquipments: [],
      noteAttachment: {},
      termsCondition: null,
      lineItemCalculation: {
        taxApplied: 0,
        discountValue: 0,
        adjustmentAmount: 0,
        discountType: 1,
        discountValueType: 0
      },
      reviseContract: 0,
      updateData: {
        term_conditions: null,
        admin_remark: null,
        client_remark: null,
        notify_admin: 0,
        notify_customer: 0,
        notify_engineer: 0,
        documents: []
      }
    };
  },
  components: {
    DatePicker: DatePicker,
    DateRangePicker: DateRangePicker,
    CustomerPersonDialog: CustomerPersonDialog,
    CustomerPropertyDialog: CustomerPropertyDialog,
    CustomerBillingDialog: CustomerBillingDialog,
    ContractLineItemNew: ContractLineItemNew,
    CreateUpdateTemplate: CreateUpdateTemplate,
    ContractTermsConditions: ContractTermsConditions,
    ContractNotesAttachment: ContractNotesAttachment
  },
  methods: {
    updateDuration: function updateDuration() {
      var _this$contractCreate = this.contractCreate,
          contract_start = _this$contractCreate.contract_start,
          duration_value = _this$contractCreate.duration_value,
          duration_type = _this$contractCreate.duration_type;
      this.contractCreate.contract_end = moment(contract_start).add(duration_value, duration_type).format("YYYY-MM-DD");
    },
    updateLineItem: function updateLineItem(rows) {
      this.lineItem = rows;
    },
    updateEquipment: function updateEquipment(rows) {
      this.equipments = rows;
    },
    updateLineItemCalculation: function updateLineItemCalculation(row) {
      this.lineItemCalculation.taxApplied = row.apply_tax;
      this.lineItemCalculation.discountValue = row.discount_value;
      this.lineItemCalculation.adjustmentAmount = row.adjustment;
      this.lineItemCalculation.discountType = 1;
      this.lineItemCalculation.discountValueType = row.discount_value_type;
    },
    updateSales: function updateSales() {
      var sales_executive = find(this.salesExecutiveList, {
        id: this.contractCreate.sales_executive
      });

      if (sales_executive) {
        this.contractCreate.sales = sales_executive.full_name;
      }
    },
    routeToServiceHistory: function routeToServiceHistory() {
      var _this2 = this;

      this.forcePush = true;
      this.$nextTick(function () {
        _this2.$router.push(_this2.getDefaultRoute("property.detail", {
          params: {
            id: _this2.property.id
          },
          query: {
            tab: "property-history"
          }
        }));
      });
    },
    closeDialog: function closeDialog() {
      this.customerPersonDialog = false;
      this.customerBillingDialog = false;
      this.customerPropertyDialog = false;
    },
    selectCustomerPerson: function selectCustomerPerson(param) {
      if (this.person_type == "property") {
        if (this.contractPropertyPerson == param) {
          this.closeDialog();
          return false;
        }

        this.contractPropertyPerson = param;
      }

      if (this.person_type == "billing") {
        if (this.contractBillingPerson == param) {
          this.closeDialog();
          return false;
        }

        this.contractBillingPerson = param;
      }

      this.closeDialog();
      this.pushToRouteContract();
    },
    selectCustomerProperty: function selectCustomerProperty(param) {
      if (this.contractProperty == param) {
        this.closeDialog();
        return false;
      }

      this.contractProperty = param;
      this.closeDialog();
      this.pushToRouteContract();
    },
    selectCustomerBilling: function selectCustomerBilling(param) {
      if (this.contractBilling == param) {
        this.closeDialog();
        return false;
      }

      this.contractBilling = param;
      this.closeDialog();
      this.pushToRouteContract();
    },
    pushToRouteContract: function pushToRouteContract() {
      var _this3 = this;

      this.$router.replace(this.getDefaultRoute("contract.create", {
        query: {
          customer: this.contractCustomer,
          billing: this.contractBilling,
          property: this.contractProperty,
          property_person: this.contractPropertyPerson,
          billing_person: this.contractBillingPerson,
          duplicate: this.duplicateContract,
          revise: this.reviseContract,
          ticket: this.ticketId,
          visit: this.visitId
        }
      })).then(function () {
        _this3.getOptions();
      });
    },
    updateOrCreate: function updateOrCreate(type) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this, validateStatus, formErrors, i, line_items, validateLineItem, REQUEST_TYPE, REQUEST_URL, formData, contract;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this = _this4;
                validateStatus = _this.$refs.contractForm.validate();
                formErrors = _this.validateForm(_this.$refs.contractForm);

                if (!formErrors.length) {
                  _context.next = 6;
                  break;
                }

                for (i = 0; i < formErrors.length; i++) {
                  ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
                }

                return _context.abrupt("return", false);

              case 6:
                line_items = concat(_this.equipments, _this.lineItem);
                validateLineItem = compact(map(line_items, function (row) {
                  return row.product_id;
                }));

                if (!isEmpty(validateLineItem)) {
                  _context.next = 11;
                  break;
                }

                ErrorEventBus.$emit("update:error", InitializeError("Select product/service/equipment then try again."));
                return _context.abrupt("return", false);

              case 11:
                if (validateStatus) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return", false);

              case 13:
                REQUEST_TYPE = POST;
                REQUEST_URL = "contract";

                if (_this.contractId && _this.contractId > 0) {
                  REQUEST_TYPE = PUT;
                  REQUEST_URL = "contract/" + _this.contractId;
                }

                if (_this.reviseContract && _this.reviseContract > 0) {
                  type = "revise";
                  REQUEST_TYPE = PUT;
                  REQUEST_URL = "contract/" + _this.reviseContract;
                }

                formData = new Object({
                  action: typeof type == "string" ? type : undefined,
                  ticket: _this.ticketId,
                  visit: _this.visitId,
                  invoice: _this.invoiceId,
                  customer: _this.contractCustomer,
                  billing: _this.contractBilling,
                  property: _this.contractProperty,
                  property_person: _this.contractPropertyPerson,
                  billing_person: _this.contractBillingPerson,
                  job_title: _this.contractCreate.job_title,
                  description: _this.contractCreate.description,
                  property_person_notify: toSafeInteger(_this.contractCreate.property_person_notify),
                  billing_person_notify: toSafeInteger(_this.contractCreate.billing_person_notify),
                  barcode: _this.contractCreate.barcode,
                  reference: _this.contractCreate.reference,
                  duration_value: _this.contractCreate.duration_value,
                  duration_type: _this.contractCreate.duration_type,
                  contract_start: _this.contractCreate.contract_start,
                  contract_end: _this.contractCreate.contract_end,
                  rating: _this.contractCreate.rating,
                  sales_executive: _this.contractCreate.sales_executive,
                  prepared_by: _this.contractCreate.prepared_by,
                  is_contract: toSafeInteger(_this.contractCreate.is_contract),
                  duration: _this.contractCreate.duration || [],
                  total_service: toSafeInteger(_this.contractCreate.total_service),
                  sales: _this.contractCreate.sales,
                  documents: _this.noteAttachment.documents,
                  admin_remark: _this.noteAttachment.admin_notes,
                  client_remark: _this.noteAttachment.client_notes,
                  term_conditions: _this.termsCondition,
                  tax_applied: _this.lineItemCalculation.taxApplied,
                  discount_value: _this.lineItemCalculation.discountValue,
                  adjustment: _this.lineItemCalculation.adjustmentAmount,
                  discount_type: _this.lineItemCalculation.discountType,
                  discount_value_type: _this.lineItemCalculation.discountValueType
                });

                if (_this.contractCreated) {
                  _context.next = 32;
                  break;
                }

                _context.prev = 19;
                _context.next = 22;
                return _this.$store.dispatch(REQUEST_TYPE, {
                  url: REQUEST_URL,
                  data: formData
                });

              case 22:
                contract = _context.sent;

                if (!isEmpty(contract)) {
                  _this.contractId = toSafeInteger(contract.data.id);
                  _this.contractCreated = true;
                }

                _context.next = 32;
                break;

              case 26:
                _context.prev = 26;
                _context.t0 = _context["catch"](19);

                _this.logError(_context.t0);

                _this.formLoading = false;
                ErrorEventBus.$emit("update:error", InitializeError("Contract is not created. Please try again."));
                return _context.abrupt("return", false);

              case 32:
                if (!(!_this.lineItemCreated && _this.contractCreated && _this.contractId)) {
                  _context.next = 45;
                  break;
                }

                _context.prev = 33;
                _context.next = 36;
                return _this.CreateLineItems({
                  type: "contract",
                  parent: _this.contractId,
                  formData: line_items
                });

              case 36:
                _this.lineItemCreated = true;
                _context.next = 45;
                break;

              case 39:
                _context.prev = 39;
                _context.t1 = _context["catch"](33);

                _this.logError(_context.t1);

                _this.formLoading = false;
                ErrorEventBus.$emit("update:error", InitializeError("Line items are not created. Please try again."));
                return _context.abrupt("return", false);

              case 45:
                _this.formLoading = false;

                _this.$nextTick(function () {
                  _this.$router.push(_this.getDefaultRoute("contract", {
                    query: {
                      status: "all"
                    }
                  }));
                });

              case 47:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[19, 26], [33, 39]]);
      }))();
    },
    getLineItems: function getLineItems(data) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.$store.dispatch(QUERY, {
          url: "line-item/new",
          data: data
        }).then(function (_ref) {
          var data = _ref.data;
          resolve(data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    setUpdateData: function setUpdateData(param) {
      var _this = this;

      _this.contractCreate.job_title = param.job_title;
      _this.contractCreate.description = param.description;
      _this.contractCreate.property_person_notify = param.property_person_notify;
      _this.contractCreate.billing_person_notify = param.billing_person_notify;
      _this.contractCreate.rating = param.rating;
      _this.contractCreate.reference = param.reference;
      _this.contractCreate.prepared_by = param.prepared_by;
      _this.contractCreate.is_contract = param.is_contract;
      _this.contractCreate.duration_value = param.duration_value;
      _this.contractCreate.duration_type = param.duration_type;
      _this.contractCreate.contract_start = param.contract_start;
      _this.contractCreate.contract_end = param.contract_end;
      _this.contractCreate.duration = param.duration;
      _this.contractCreate.total_service = param.total_service;
      _this.contractCreate.discount_value = param.discount_value;
      _this.contractCreate.discount_value_type = param.discount_value_type;
      _this.contractCreate.tax_applied = param.tax_applied;
      _this.contractCreate.adjustment = param.adjustment;
      _this.updateData.term_conditions = param.term_conditions;
      _this.updateData.admin_remark = param.admin_remark;
      _this.updateData.client_remark = param.client_remark;
      _this.updateData.notify_admin = param.notify_admin;
      _this.updateData.notify_customer = param.notify_customer;
      _this.updateData.documents = param.documents;
      var sales_executive = find(_this.salesExecutiveList, {
        full_name: param.sales
      });

      if (sales_executive) {
        _this.contractCreate.sales = sales_executive.full_name;
        _this.contractCreate.sales_executive = sales_executive.id;
      }

      _this.getLineItems({
        contract: _this.contractId
      }).then(function (data) {
        var result = [];

        for (var i = 0; i < data.length; i++) {
          result.push({
            id: data[i].id,
            group: data[i].group,
            group_primary: data[i].group_primary,
            product: data[i].product,
            product_id: data[i].product_id,
            serial_no: data[i].serial_no,
            eq_model: data[i].eq_model,
            location: data[i].location,
            product_type: data[i].product_type,
            has_warranty: data[i].has_warranty,
            warranty: data[i].warranty,
            description: data[i].description,
            rate: data[i].rate,
            quantity: data[i].quantity,
            uom: data[i].uom,
            total: data[i].total,
            visit_barcode: data[i].visit_barcode
          });
        }

        _this.$nextTick(function () {
          _this.dbLineItems = filter(result, function (row) {
            return row.product_type == "goods" || row.product_type == "service";
          });
          _this.dbEquipments = filter(result, {
            product_type: "equipment"
          });
        });
      }).catch(function (error) {
        _this.logError(error);
      });
    },
    setReviseData: function setReviseData(param) {
      var _this = this;

      _this.contractCreate.job_title = param.job_title;
      _this.contractCreate.description = param.description;
      _this.contractCreate.property_person_notify = param.property_person_notify;
      _this.contractCreate.billing_person_notify = param.billing_person_notify;
      _this.contractCreate.rating = param.rating;
      _this.contractCreate.reference = param.reference;
      _this.contractCreate.sales_executive = param.sales_executive;
      _this.contractCreate.prepared_by = param.prepared_by;
      _this.contractCreate.is_contract = param.is_contract;
      _this.contractCreate.duration_value = param.duration_value;
      _this.contractCreate.duration_type = param.duration_type;
      _this.contractCreate.contract_start = param.contract_start;
      _this.contractCreate.contract_end = param.contract_end;
      _this.contractCreate.duration = param.duration;
      _this.contractCreate.total_service = param.total_service;
      _this.contractCreate.discount_value = param.discount_value;
      _this.contractCreate.discount_value_type = param.discount_value_type;
      _this.contractCreate.tax_applied = param.tax_applied;
      _this.contractCreate.adjustment = param.adjustment;
      _this.contractCreate.sales = param.sales;
      _this.updateData.term_conditions = param.term_conditions;
      _this.updateData.admin_remark = param.admin_remark;
      _this.updateData.client_remark = param.client_remark;
      _this.updateData.notify_admin = param.notify_admin;
      _this.updateData.notify_customer = param.notify_customer;
      _this.updateData.documents = [];
      var sales_executive = find(_this.salesExecutiveList, {
        full_name: param.sales
      });

      if (sales_executive) {
        _this.contractCreate.sales = sales_executive.full_name;
        _this.contractCreate.sales_executive = sales_executive.id;
      }

      _this.getLineItems({
        contract: _this.reviseContract
      }).then(function (data) {
        var result = [];

        for (var i = 0; i < data.length; i++) {
          result.push({
            id: null,
            group: data[i].group,
            group_primary: data[i].group_primary,
            product: data[i].product,
            product_id: data[i].product_id,
            serial_no: data[i].serial_no,
            eq_model: data[i].eq_model,
            location: data[i].location,
            product_type: data[i].product_type,
            has_warranty: data[i].has_warranty,
            warranty: data[i].warranty,
            description: data[i].description,
            rate: data[i].rate,
            quantity: data[i].quantity,
            uom: data[i].uom,
            total: data[i].total,
            visit_barcode: data[i].visit_barcode
          });
        }

        _this.$nextTick(function () {
          _this.dbLineItems = filter(result, function (row) {
            return row.product_type == "goods" || row.product_type == "service";
          });
          _this.dbEquipments = filter(result, {
            product_type: "equipment"
          });
        });
      }).catch(function (error) {
        _this.logError(error);
      });
    },
    setDuplicateData: function setDuplicateData(param) {
      var _this = this;

      _this.contractCreate.job_title = param.job_title;
      _this.contractCreate.description = param.description;
      _this.contractCreate.property_person_notify = param.property_person_notify;
      _this.contractCreate.billing_person_notify = param.billing_person_notify;
      _this.contractCreate.rating = param.rating;
      _this.contractCreate.reference = "Contract # ".concat(param.barcode);
      _this.contractCreate.sales_executive = param.sales_executive;
      _this.contractCreate.prepared_by = param.prepared_by;
      _this.contractCreate.is_contract = param.is_contract;
      _this.contractCreate.duration_value = param.duration_value;
      _this.contractCreate.duration_type = param.duration_type;
      _this.contractCreate.contract_start = param.contract_start;
      _this.contractCreate.contract_end = param.contract_end;
      _this.contractCreate.duration = param.duration;
      _this.contractCreate.total_service = param.total_service;
      _this.contractCreate.discount_value = param.discount_value;
      _this.contractCreate.discount_value_type = param.discount_value_type;
      _this.contractCreate.tax_applied = param.tax_applied;
      _this.contractCreate.adjustment = param.adjustment;
      _this.contractCreate.sales = param.sales;
      _this.updateData.term_conditions = param.term_conditions;
      _this.updateData.admin_remark = param.admin_remark;
      _this.updateData.client_remark = param.client_remark;
      _this.updateData.notify_admin = param.notify_admin;
      _this.updateData.notify_customer = param.notify_customer;
      _this.updateData.documents = [];
      var sales_executive = find(_this.salesExecutiveList, {
        full_name: param.sales
      });

      if (sales_executive) {
        _this.contractCreate.sales = sales_executive.full_name;
        _this.contractCreate.sales_executive = sales_executive.id;
      }

      _this.getLineItems({
        contract: _this.duplicateContract
      }).then(function (data) {
        var result = [];

        for (var i = 0; i < data.length; i++) {
          result.push({
            id: null,
            group: data[i].group,
            group_primary: data[i].group_primary,
            product: data[i].product,
            product_id: data[i].product_id,
            serial_no: data[i].serial_no,
            eq_model: data[i].eq_model,
            location: data[i].location,
            product_type: data[i].product_type,
            has_warranty: data[i].has_warranty,
            warranty: data[i].warranty,
            description: data[i].description,
            rate: data[i].rate,
            quantity: data[i].quantity,
            uom: data[i].uom,
            total: data[i].total,
            visit_barcode: data[i].visit_barcode
          });
        }

        _this.$nextTick(function () {
          _this.dbLineItems = filter(result, function (row) {
            return row.product_type == "goods" || row.product_type == "service";
          });
          _this.dbEquipments = filter(result, {
            product_type: "equipment"
          });
        });
      }).catch(function (error) {
        _this.logError(error);
      });
    },
    setTicketData: function setTicketData(param) {
      var _this = this;

      _this.contractCreate.job_title = param.title;
      _this.contractCreate.description = param.description;
      _this.contractCreate.property_person_notify = param.property_person_notify;
      _this.contractCreate.billing_person_notify = param.billing_person_notify;
      _this.contractCreate.reference = "Visit # ".concat(param.barcode);
      _this.contractCreate.discount_value = param.discount_value;
      _this.contractCreate.discount_value_type = param.discount_value_type;
      _this.contractCreate.tax_applied = param.tax_applied;
      _this.contractCreate.adjustment = param.adjustment;
      _this.updateData.term_conditions = param.term_conditions;
      _this.updateData.admin_remark = param.admin_remark;
      _this.updateData.client_remark = param.client_remark;
      _this.updateData.notify_admin = param.notify_admin;
      _this.updateData.notify_customer = param.notify_customer;
      _this.updateData.documents = [];

      _this.getLineItems({
        job: _this.ticketId,
        visit: _this.visitId
      }).then(function (data) {
        var result = [];

        for (var i = 0; i < data.length; i++) {
          result.push({
            id: null,
            group: data[i].group,
            group_primary: data[i].group_primary,
            product: data[i].product,
            product_id: data[i].product_id,
            serial_no: data[i].serial_no,
            eq_model: data[i].eq_model,
            location: data[i].location,
            product_type: data[i].product_type,
            has_warranty: data[i].has_warranty,
            warranty: data[i].warranty,
            description: data[i].description,
            rate: data[i].rate,
            quantity: data[i].quantity,
            uom: data[i].uom,
            total: data[i].total,
            visit_barcode: data[i].visit_barcode
          });
        }

        _this.$nextTick(function () {
          _this.dbLineItems = filter(result, function (row) {
            return row.product_type == "goods" || row.product_type == "service";
          });
          _this.dbEquipments = filter(result, {
            product_type: "equipment"
          });
        });
      }).catch(function (error) {
        _this.logError(error);
      });
    },
    setInvoiceData: function setInvoiceData(param) {
      var _this = this;

      _this.contractCreate.job_title = param.title;
      _this.contractCreate.property_person_notify = param.property_person_notify;
      _this.contractCreate.billing_person_notify = param.billing_person_notify;
      _this.contractCreate.reference = "Invoice # ".concat(param.barcode);
      _this.contractCreate.discount_value = param.discount_value;
      _this.contractCreate.discount_value_type = param.discount_value_type;
      _this.contractCreate.tax_applied = param.tax_applied;
      _this.contractCreate.adjustment = param.adjustment;
      _this.updateData.term_conditions = param.term_conditions;
      _this.updateData.admin_remark = param.admin_remark;
      _this.updateData.client_remark = param.client_remark;
      _this.updateData.notify_admin = param.notify_admin;
      _this.updateData.notify_customer = param.notify_customer;
      _this.updateData.documents = [];

      _this.getLineItems({
        invoice: _this.invoiceId
      }).then(function (data) {
        var result = [];

        for (var i = 0; i < data.length; i++) {
          result.push({
            id: null,
            group: data[i].group,
            group_primary: data[i].group_primary,
            product: data[i].product,
            product_id: data[i].product_id,
            serial_no: data[i].serial_no,
            eq_model: data[i].eq_model,
            location: data[i].location,
            product_type: data[i].product_type,
            has_warranty: data[i].has_warranty,
            warranty: data[i].warranty,
            description: data[i].description,
            rate: data[i].rate,
            quantity: data[i].quantity,
            uom: data[i].uom,
            total: data[i].total,
            visit_barcode: data[i].visit_barcode
          });
        }

        _this.$nextTick(function () {
          _this.dbLineItems = filter(result, function (row) {
            return row.product_type == "goods" || row.product_type == "service";
          });
          _this.dbEquipments = filter(result, {
            product_type: "equipment"
          });
        });
      }).catch(function (error) {
        _this.logError(error);
      });
    },
    getOptions: function getOptions() {
      var _this5 = this;

      this.pageLoading = true;
      this.$store.dispatch(QUERY, {
        url: "contract/options",
        data: {
          duplicate: this.duplicateContract,
          revise: this.reviseContract,
          contract: this.contractId,
          invoice: this.invoiceId,
          ticket: this.ticketId,
          visit: this.visitId,
          customer: this.contractCustomer,
          billing: this.contractBilling,
          property: this.contractProperty,
          property_person: this.contractPropertyPerson,
          billing_person: this.contractBillingPerson
        }
      }).then(function (_ref2) {
        var data = _ref2.data;

        if (data.user && data.user.full_name) {
          _this5.contractCreate.prepared_by = data.user.full_name;
        }

        if (data.barcode) {
          _this5.contractCreate.barcode = data.barcode;
        }

        if (!isEmpty(data.sales_users)) {
          _this5.salesExecutiveList = data.sales_users;
        }

        if (!isEmpty(data.options)) {
          _this5.barcodeSetting = data.options;
        }

        if (!isEmpty(data.contract)) {
          _this5.setUpdateData(data.contract);
        }

        if (!isEmpty(data.revise)) {
          _this5.setReviseData(data.revise);
        }

        if (!isEmpty(data.invoice)) {
          _this5.setInvoiceData(data.invoice);
        }

        if (!isEmpty(data.ticket)) {
          _this5.setTicketData(data.ticket);
        }

        if (!isEmpty(data.duplicate)) {
          _this5.setDuplicateData(data.duplicate);
        }

        if (!isEmpty(data.customer)) {
          _this5.customer = data.customer;
          _this5.contractCustomer = _this5.customer.id;
        }

        if (!isEmpty(data.billing)) {
          _this5.billing = data.billing;
          _this5.contractBilling = _this5.billing.id;
        }

        if (!isEmpty(data.property)) {
          _this5.property = data.property;
          _this5.contractProperty = _this5.property.id;
        }

        if (!isEmpty(data.property_person)) {
          _this5.property_contact_person = data.property_person;
          _this5.contractPropertyPerson = _this5.property_contact_person.id;
        }

        if (!isEmpty(data.billing_person)) {
          _this5.billing_contact_person = data.billing_person;
          _this5.contractBillingPerson = _this5.billing_contact_person.id;
        }
      }).catch(function (error) {
        _this5.logError(error);

        _this5.goBack();
      }).finally(function () {
        _this5.pageLoading = false;
      });
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    this.getOptions();
    this.$store.dispatch(SET_BREADCRUMB, [{
      title: "Contract",
      route: "contract"
    }, {
      title: "Create"
    }]);
    TermConditionEventBus.$on("update:term-condition", function (argument) {
      _this6.termsCondition = argument;
    });
    NoteAttachmentEventBus.$on("update:notes-attachment", function (argument) {
      _this6.noteAttachment = argument;
    });
  },
  beforeMount: function beforeMount() {
    this.contractId = toSafeInteger(this.$route.params.id);
    this.contractCustomer = toSafeInteger(this.$route.query.customer);
    this.contractBilling = toSafeInteger(this.$route.query.billing);
    this.contractProperty = toSafeInteger(this.$route.query.property);
    this.contractPropertyPerson = toSafeInteger(this.$route.query.property_person);
    this.contractBillingPerson = toSafeInteger(this.$route.query.billing_person);
    this.duplicateContract = toSafeInteger(this.$route.query.duplicate);
    this.reviseContract = toSafeInteger(this.$route.query.revise);
    this.ticketId = toSafeInteger(this.$route.query.ticket);
    this.visitId = toSafeInteger(this.$route.query.visit);
    this.invoiceId = toSafeInteger(this.$route.query.invoice);
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    var _this = this;

    if (_this.forcePush) {
      next();
    } else if (_this.contractCreated && _this.lineItemCreated) {
      next();
    } else {
      _this.routePreventDialog = true;
      PreventDialogEventBus.$on("stay-on-page", function () {
        _this.routePreventDialog = false;
        next(false);
      });
      PreventDialogEventBus.$on("leave-page", function () {
        _this.routePreventDialog = false;
        next();
      });
    }
  }
};